
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-postcards",
      function () {
        return require("private-next-pages/real-estate-postcards.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-postcards"])
      });
    }
  